import React from 'react';
import styles from './index.module.scss';

interface LoaderPanelProps {
  active: boolean;
}

const LoaderPanel: React.FC<LoaderPanelProps> = ({ active }) => {

  return (
    <div className={styles.loaderPanel + (active ? ' ' + styles.active : '')}>
      <div className={styles.loader}></div>
    </div>
  );
};

export default LoaderPanel;